import { LucideIcon, SearchX } from 'lucide-react';

interface NoResultsProps {
  icon?: LucideIcon;
  title?: string;
  subtitle?: string;
}

export default function NoResults({
  icon: Icon = SearchX,
  title = 'No results found!',
  subtitle = 'Try adjusting your filters or search keywords.',
}: NoResultsProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-4 py-16 text-muted-foreground relative">
      <Icon className="w-24 h-24 opacity-10 absolute inset-1/2 -translate-x-1/2 -translate-y-1/2" />
      <div className="relative z-10">
        <p className="text-2xl font-semibold">{title}</p>
        <p className="mt-2 text-sm">{subtitle}</p>
      </div>
    </div>
  );
}
